module.exports = __webpack_public_path__ + "img/OVCA_CD8Tex.c9242c3a.png";